export const SortOrder = {
  asc: 1,
  desc: 2,
};

export const PhoneState = {
  ERROR: 'ERROR',
  REGISTERED: 'REGISTERED',
}